import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67b09b25"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-12 col-lg-8 col-md-8 g-0" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "employee-to" }, " Primary Diagnosis: ", -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-1" }, "*", -1 /* HOISTED */))
const _hoisted_4 = { class: "col-12 col-lg-4 col-md-4 ps-2 pt-4 mt-1 g-0" }
const _hoisted_5 = {
  key: 0,
  class: "diagnosis-outline col-12"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ps-2 mb-0" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Questionable Encounter Code Entered")
], -1 /* HOISTED */))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "px-4 pt-2",
  for: "employee-to"
}, " Other Diagnoses: ", -1 /* HOISTED */))
const _hoisted_9 = {
  key: 0,
  class: "col-12 col-lg-8 col-md-8 g-0"
}
const _hoisted_10 = { class: "col-12 col-lg-4 col-md-4 ps-2 g-0" }
const _hoisted_11 = { class: "w-100 d-flex justify-content-end pt-2 pb-1 px-1" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "py-3 px-4 g-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Patient Diagnosis",
    type: "his-section",
    "full-height": false
  }, {
    content: _withCtx(() => [
      _createElementVNode("section", null, [
        _createElementVNode("div", {
          class: _normalizeClass(["row g-0", `${_ctx.questionableEncounterCode ? 'has-warning px-3 py-2 mb-3' : 'px-4 py-3'}`])
        }, [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _hoisted_3,
            _createVNode(_component_TypeaheadInput, {
              placeholder: "ICD-10-CM Diagnosis",
              getData: _ctx.diagnosisFetchByDiagnosis,
              onValueChanged: _ctx.primaryDiagnosisChanged,
              value: _ctx.primaryDiagnosis.diagnosis,
              isError: _ctx.isPrimaryDiagnosisError
            }, null, 8 /* PROPS */, ["getData", "onValueChanged", "value", "isError"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_TypeaheadInput, {
              placeholder: "ICD-10-CM Code",
              getData: _ctx.diagnosisFetchByCode,
              onValueChanged: _ctx.primaryDiagnosisChanged,
              value: _ctx.primaryDiagnosis.code,
              isError: _ctx.isPrimaryDiagnosisError
            }, null, 8 /* PROPS */, ["getData", "onValueChanged", "value", "isError"])
          ]),
          (_ctx.questionableEncounterCode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */)
      ]),
      _hoisted_8,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherDiagnosis, (input, k) => {
        return (_openBlock(), _createElementBlock("section", {
          key: k,
          class: "d-flex row pt-1 pb-4 px-4 g-0"
        }, [
          input
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_TypeaheadInput, {
                  placeholder: "ICD-10-CM Diagnosis",
                  value: input.diagnosis,
                  getData: _ctx.diagnosisFetchByDiagnosis,
                  onValueChanged: (e) => _ctx.otherDiagnosisChanged(e, k)
                }, null, 8 /* PROPS */, ["value", "getData", "onValueChanged"])
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_TypeaheadInput, {
              placeholder: "ICD-10-CM Code",
              value: input.code,
              getData: _ctx.diagnosisFetchByCode,
              onValueChanged: (e) => _ctx.otherDiagnosisChanged(e, k)
            }, null, 8 /* PROPS */, ["value", "getData", "onValueChanged"]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", {
                onClick: ($event: any) => (_ctx.removeDiagnosis(k)),
                class: "fas fa-window-close fa-sm cursor-pointer"
              }, null, 8 /* PROPS */, _hoisted_12)
            ])
          ])
        ]))
      }), 128 /* KEYED_FRAGMENT */)),
      _createElementVNode("section", _hoisted_13, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addDiagnosis())),
          class: "btn btn-primary me-3"
        }, "Add Diagnosis")
      ])
    ]),
    _: 1 /* STABLE */
  }))
}